import { GetCustomerPortalUrlFnReq, GetCustomerPortalUrlFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class GetCustomerPortalUrlInteractor {
  private readonly getCustomerPortalUrlFn = httpsCallable<
    GetCustomerPortalUrlFnReq,
    GetCustomerPortalUrlFnRes
  >(this.functions, 'getCustomerPortalUrl');

  constructor(private readonly functions: Functions) {}

  public async execute(returnUrl: string): Promise<string> {
    const res = await this.getCustomerPortalUrlFn({ returnUrl });
    return res.data.url;
  }
}
